import { render, staticRenderFns } from "./ImportJsonBrowser.vue?vue&type=template&id=3a52fc85&scoped=true&"
import script from "./ImportJsonBrowser.vue?vue&type=script&lang=js&"
export * from "./ImportJsonBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a52fc85",
  null
  
)

export default component.exports